<!--- COMPONENTE PCVistaVolcadoDetallePartida  ---->
<!---
Descripción del componente:
---------------------------
-

Eventos del componente:
-----------------------
-  xxxxxxxxxxx ->
--->
<template>
  <div
    v-if="partidaSeleccionadaLocal != null"
    class="div-componentePCVistaVolcadoDetallePartida"
  >
    <!-- Cabecera del detalle -->
    <f7-row>
      <f7-col width="100">
        <span class="span-numeroPartida">
          {{ `${$t('common.batch').toUpperCase()} ${partidaSeleccionadaLocal.Serie}/${partidaSeleccionadaLocal.Numero}` }}
        </span>
      </f7-col>
      <f7-col width="40">
        <span class="span-ttlElemento">
          {{ $t('common.quantity') }}
        </span>
      </f7-col>
      <f7-col width="60">
        <span class="span-textoElemento">{{ partidaSeleccionadaLocal.Cantidad }}  </span>
      </f7-col>
      <f7-col width="40">
        <span class="span-ttlElemento">
          {{ $t('common.packages') }}
        </span>
      </f7-col>
      <f7-col width="60">
        <span class="span-textoElemento">{{ partidaSeleccionadaLocal.Envases }}  </span>
      </f7-col>
      <f7-col width="40">
        <span class="span-ttlElemento">
          {{ $t('common.netWeight') }}
        </span>
      </f7-col>
      <f7-col width="60">
        <span class="span-textoElemento">{{ partidaSeleccionadaLocal.PesoNeto }}  </span>
      </f7-col>
      <f7-col width="40">
        <span class="span-ttlElemento">
          {{ $t('production.dump.batchDetails.palletsNum') }}
        </span>
      </f7-col>
      <f7-col width="60">
        <span class="span-textoElemento">{{ partidaSeleccionadaLocal.Existencias.length }}  </span>
      </f7-col>
    </f7-row>

    <div class="div-ttlDetallePartida">
      {{ $t('production.dump.batchDetails.title') }}
    </div>

    <!-- Información detalle -->
    <div
      v-if="partidaSeleccionadaLocal.Existencias != null"
      class="div-informacionDelDetalle"
    >
      <div class="div-elementoSeparador-total" />
      <div
        v-for="existencia in partidaSeleccionadaLocal.Existencias"
        :key="existencia.Id"
        class="div-registroNumeroSerie"
        @click="VerDetalle(existencia)"
      >
        <f7-row class="row-registroNumeroSerie">
          <f7-col width="80">
            <span class="span-span-ttl-ns"> {{ existencia.NumeroSerie }} </span>
            <br>
          </f7-col>
          <f7-col
            width="20"
            class="col-envasesDisponibles"
          >
            <span class="span-envasesDisponibles">
              {{ $t('common.packages') }}
            </span>
          </f7-col>
        </f7-row>
        <f7-row class="row-registroArticulo">
          <f7-col
            width="70"
            class="col-productoPartida"
          >
            <span class="span-productoNumeroSerie"> {{ existencia.Articulo.Nombre }} </span>
          </f7-col>
          <f7-col
            width="30"
            class="col-cantidadEnvasesDisponibles"
          >
            <img
              class="img-iconoEnvases"
              alt="iconEnvases"
              src="@/static/icons/ic_box.svg"
            >
            <span class="span-existenciasEnvases">{{ existencia.Cajas }} </span>
          </f7-col>
        </f7-row>
      </div>
    </div>

    <!-- Boton Flotante Volcar todo -->
    <div class="fab fab-extended fab-center-bottom">
      <a
        href="#"
        class="a-fab"
        @click="VolcadoTotalMercancia"
      >
        <div class="fab-text">
          {{ $t('production.dump.batchDetails.btnDumpEverythingText') }}
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';
import { useSettingRef } from '@erpagroapp/settings';

import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';
import eventBus from '@/js/event-bus'; // Import the EventBus.
import { HiDialog, HiNotification } from '@/js/common/HINotificationSupport';
import { f7 } from 'framework7-vue';

export default {
  name: 'PCVistaVolcadoDetallePartida',

  emits: ['mercanciaVolcada'],

  data() {
    return {
      partidaSeleccionadaLocal: null,
      confirmacionAntesDeVolcar: useSettingRef('Volcado.ConfirmacionAntesDeVolcar'),
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'puntoDeVolcadoSeleccionado',
    ]),

    ...mapWritableState(useTraceabilityStore, [
      'partidaSeleccionada',
      'unidadLogisticaSeleccionada',
    ]),
  },

  created() {
    this.partidaSeleccionadaLocal = this.partidaSeleccionada;
    this.CargarExistenciasPorIdentificadorDePartida();

    this.ComprobarVolcadoSinConfirmacion();
  },
  beforeUnmount() {
    this.partidaSeleccionada = null; // Restablecemos la partida seleccionada.
  },
  methods: {
    CargarExistenciasPorIdentificadorDePartida() {
      Log(this, this.CargarExistenciasPorIdentificadorDePartida.name);
      const self = this;
      HiDialog.Preloader(true, this.$t('production.dump.batchDetails.loadingData.preloaderText'));
      ConexionTA.callObteneElementoDeProduccionPorIdPartida(this.partidaSeleccionadaLocal.Id, true).then((result) => {
        if (result.Valor) {
          // self.ProcesarRespuestaExistenciasPorIdentificadorDePartida(JSON.parse(result.Mensaje));
          self.partidaSeleccionadaLocal = JSON.parse(result.Mensaje);
          HiDialog.Preloader(false);
        } else {
          HiDialog.Preloader(false);
          HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        }
      })
        .catch((error) => {
          HiDialog.Preloader(false);
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          LogError(error);
        });
    },

    async VolcadoTotalMercancia() {
      Log(this, this.VolcadoTotalMercancia.name);
      await this.VolcadoDeMercanciaPorPartida();
      this.$emit('mercanciaVolcada');
      f7.views.main.router.back(); // Siempre salimos ya que no sabemos si se volco todo o solo parte.
    },

    async VerDetalle(objExistencia) {
      Log(this, this.VerDetalle.name);

      // setUnidadLogisticaSeleccionada({ Id: objExistencia.IdUnidadLogistica });
      // f7.views.main.router.navigate('/trazabilidadAutomatizada/volcado/frmVolcarMercanciaDetalle');
      const objAns = await this.ObtenerInformacionArticuloNumeroSerie(objExistencia.IdUnidadLogistica);
      if (objAns === null) {
        return;
      }
      this.unidadLogisticaSeleccionada = objAns;
      f7.views.main.router.navigate('/production/traceability/dumpAndRecoverMerchandise/dump/FrmDumpMerchandiseULView');
    },

    /** Método ObtenerInformacionArticuloNumeroSerie */
    async ObtenerInformacionArticuloNumeroSerie(idAns) {
      Log(this, this.ObtenerInformacionArticuloNumeroSerie.name);
      HiDialog.Preloader(true, this.$t('production.dump.batchDetails.get.preloaderText'));
      const result = await ConexionTA.callObteneElementoDeProduccionPorIdArticuloNumeroSerie(idAns);
      if (result.Valor) {
        HiDialog.Preloader(false);
        return result.UnidadContenedora;
      }
      HiDialog.Preloader(false);
      HiNotification.Alert(result.Mensaje, this.$t('common.error'));
      return null;

      /*

        if (result.Valor) {
          Log(result.UnidadContenedora);
          HiDialog.Preloader(false);
          return result.UnidadContenedora;
        }
        HiDialog.Preloader(false);
        HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        return null;
      })
        .catch((error) => {
          HiDialog.Preloader(false);
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          LogError(error);
          return null;
        });
        */
    },

    async VolcadoDeMercanciaPorPartida() {
      Log(this, this.VolcadoDeMercanciaPorPartida.name);
      const self = this;
      HiDialog.Preloader(true, this.$t('production.dump.batchDetails.dump.preloaderText'));
      const puntoDeVolcado = this.puntoDeVolcadoSeleccionado;
      const idPartida = this.partidaSeleccionadaLocal.Id;
      await ConexionTA.callVolcarPartidaCompleta(puntoDeVolcado.Id, idPartida).then((result) => {
        if (result.Valor) {
          self.NotificarVolcadoDeMercancia();
          HiDialog.Preloader(false);
        } else {
          HiDialog.Preloader(false);
          HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        }
      })
        .catch((error) => {
          HiDialog.Preloader(false);
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          LogError(this, this.VolcadoDeMercanciaPorPartida.name, error);
        });
    },

    ComprobarVolcadoSinConfirmacion() {
      Log(this, this.ComprobarVolcadoSinConfirmacion.name);
      if (this.confirmacionAntesDeVolcar) {
        return;
      } // Continuamos el proceso normal.
      this.VolcadoTotalMercancia(); // volcado sin confirmación activo.
    },

    NotificarVolcadoDeMercancia() {
      Log(this, this.NotificarVolcadoDeMercancia.name);
      this.GenerarNoticacion(this.$t('production.dump.batchDetails.dump.successToastText'));
      eventBus.emit('mercanciaVolcada');
    },

    GenerarNoticacion(mensaje) {
      HiNotification.Toast(mensaje, 4000);
    },
  },
};
</script>

<style scoped>
.div-componentePCVistaVolcadoDetallePartida {
  margin: 15px;
}

.span-numeroPartida {
  color: var(--his-darkgray);
  font-size: 22px;
}

.span-span-ttl-ns {
  color: var(--his-darkgray);
  font-size: 18px;
}

.span-ttlElemento {
  color: var(--his-ash-gray);
  font-size: 14px;
  font-weight: 400;
}

.span-textoElemento {
  color: #009ba6;
  font-size: 14px;
  font-weight: 600;
}

.row {
  padding-bottom: 15px;
}

.div-opcionesActionsVolcadoParcial {
  padding: 17px;
}

.div-componenteUCUnidadMedidaKiloYEnvase {
  margin-right: 18px;
  margin-top: 18px;
  margin-bottom: 9px;
}

.div-registroNumeroSerie {
  border-bottom: 1px solid var(--his-disabled);
  margin-bottom: 2px;
  padding: 8px;
}

.row-registroNumeroSerie {
  padding-bottom: 0;
}

.row-registroArticulo {
  padding-bottom: 0;
}

.span-envasesDisponibles {
  font-size: 20px;
  color: var(--his-silver);
  text-align: right;
  display: flex;
  justify-content: center;
}

.span-productoNumeroSerie {
  font-size: 17px;
  color: #009ba6;
  padding-top: 7px;
}

.col-cantidadEnvasesDisponibles {
  text-align: right;
}

.span-existenciasEnvases {
  font-size: 20px;
  color: #282829;
  text-align: right;
}

.md .fab[class*="-bottom"] {
  position: fixed;
}

.md .fab > a,
.md .fab-buttons a {
  color: #fff;
  background: var(--his-darkgray);
  padding: 5px;
  min-width: 200px;
}

.div-informacionDelDetalle {
  margin-bottom: 85px;
}

.div-ttlDetallePartida {
  color: #24253d;
  text-transform: none;
  font-size: 22px;
}
</style>
